import React from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { CssAnimation } from './CssAnimation.jsx';

export function TextContent(props) {

  const { 
    heading, 
    subheading, 
    body, 
    HeadingTag, 
    headingSize, 
    subheadingSize, 
    bodySize,
    underline,
    cssAnimation,
    cssAnimationTrigger,
    modifier
  } = props;

  const block = 'c-text-content';

  return (
    <div className={classNames({
      [block]: true,
      [`${block}--${modifier}`]: modifier
    })}>
      {
        subheading &&
          <CssAnimation 
          enter={{ name: 'short-slide-up-fade-in', duration: 1 }} 
          triggerEnter={cssAnimationTrigger}
          {...(cssAnimation & { retrigger: subheading })}
          disable={!cssAnimation}
          >
            <div className={`${block}__text-subheading ${subheadingSize}`}>
              { subheading }
            </div>
          </CssAnimation>
      }
      {
        heading &&
          <CssAnimation
          enter={{ name: 'short-slide-up-fade-in', duration: 1, delay: '0.25, hidden' }}
          triggerEnter={cssAnimationTrigger}
          {...(cssAnimation & { retrigger: heading })}
          disable={!cssAnimation}
          >
            <HeadingTag>
              <CssAnimation
              enter={{ name: 'draw-short-underline', target: 'psuedo-element-after', duration: 1, delay: '0.5, hidden' }}
              triggerEnter={cssAnimationTrigger}
              {...(cssAnimation & { retrigger: heading })}
              disable={!cssAnimation || !underline}
              >
                <span 
                className={classNames({
                  [`${block}__text-heading ${headingSize}`]: true,
                  [`${block}__text-heading--no-underline`]: !underline
                })}
                >
                  { heading }
                </span>
              </CssAnimation>
            </HeadingTag> 
          </CssAnimation>
      }
      {
        body &&
          <CssAnimation
          enter={{ name: 'short-slide-up-fade-in', duration: 1, delay: '0.6, hidden' }}
          triggerEnter={cssAnimationTrigger}
          {...(cssAnimation & { retrigger: body })}
          disable={!cssAnimation}
          >
            <p className={classNames({
              [`${block}__text-body`]: true,
              [bodySize]: bodySize
            })}
            >
              { body }</p>
          </CssAnimation>
      }
    </div>
  )
};

TextContent.defaultProps = { 
  HeadingTag: 'h2',
  headingSize: 'h3',
  subheadingSize: 'h5',
  underline: true,
  cssAnimation: true,
  cssAnimationTrigger: 'in-view-init'
};

TextContent.propTypes = {
  heading: propTypes.string.isRequired,
  subheading: propTypes.string,
  body: propTypes.string,
  HeadingTag: propTypes.string,
  headingSize: propTypes.string,
  subheadingSize: propTypes.string,
  bodySize: propTypes.string,
  underline: propTypes.bool,
  cssAnimation: propTypes.bool,
  cssAnimationTrigger: propTypes.oneOfType([
    propTypes.string,
    propTypes.bool
  ])
};
